import { z } from "zod"

const buildLeadDaysSchema = (label: string) =>
  z.preprocess(
    (value) => (value === null ? undefined : value),
    z
      .number({
        required_error: `${label} is required`,
        invalid_type_error: `${label} must be a number`,
      })
      .int(`${label} must be a whole number`)
      .min(0, `${label} must be between 0 and 9`)
      .max(9, `${label} must be between 0 and 9`)
  )

export const accountingSettingsFormSchema = z.object({
  paymentByAchOrVirtualCcLeadDays: buildLeadDaysSchema("Payment by ACH or Virtual Credit Card"),
  paymentByCheckLeadDays: buildLeadDaysSchema("Payment by Check"),
  paymentByWireLeadDays: buildLeadDaysSchema("Payment by Wire"),
})

// FormNumericField emits `number | null`; the form input type keeps `null` so React
// Hook Form can hold cleared inputs without an unsafe cast. The schema preprocesses
// `null` → `undefined`, which surfaces the `required_error` message on submit.
export interface AccountingSettingsFormValues {
  paymentByAchOrVirtualCcLeadDays: number | null
  paymentByCheckLeadDays: number | null
  paymentByWireLeadDays: number | null
}
